import { render, staticRenderFns } from "./collectionFrequencyRecord.vue?vue&type=template&id=63bcb482&scoped=true&"
import script from "./collectionFrequencyRecord.vue?vue&type=script&lang=js&"
export * from "./collectionFrequencyRecord.vue?vue&type=script&lang=js&"
import style0 from "./collectionFrequencyRecord.vue?vue&type=style&index=0&id=63bcb482&lang=less&scoped=true&"
import style1 from "./collectionFrequencyRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bcb482",
  null
  
)

export default component.exports